import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { FormTitle, FormWrapper, FormDivider } from 'libs/forms/styles';
import Paragraph from 'components/Paragraph';
import { FullWidthDivider } from 'legacyComponents/styled/lib';
// FIXME: To remove ThemeColors
import ThemeColors from 'styles/themes/wikifactory/styles/colors';
import { ButtonGroup } from 'legacyComponents/styles';

import {
  SeatsFormWrapper,
  SeatsFormItem,
  SeatsFormItemTitle,
  SeatsFormItemValue,
  Sign,
  SeatInput,
  MaximumRemove,
  ButtonStyled,
} from 'apps/payment/styles';

export const RemoveSeatsForm = withNamespaces()(
  observer(({ paymentSpace, paymentSpacePreview }) => {
    const { subscription } = paymentSpace;
    const { seats } = subscription;
    const { removeSeatsAmount } = seats;

    const preview = paymentSpacePreview && paymentSpacePreview.preview;

    const currentMonthlyDisplayAmount = subscription.displayNextAmount;

    const displayPreview = removeSeatsAmount && preview;

    const newTotalSeats = displayPreview
      ? preview.seats.totalSubSeats
      : seats.newTotalSeats;
    const displaySavingsAmount = displayPreview
      ? preview.displayDiffAmount
      : '-';
    const newFinalDisplayAmount = displayPreview
      ? preview.displayFinalAmount
      : '-';
    const displayPerSeatAmount = displayPreview
      ? preview.displayPerSeatAmount
      : '-';

    return (
      <SeatsFormWrapper>
        <FormTitle formTitleColor={ThemeColors.destructive}>
          <Trans>Removing seats</Trans>:
        </FormTitle>
        <FormDivider />
        <FormWrapper posting={false} responsive>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>Current seats</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{seats.totalSubSeats}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>Remove seats:</Paragraph>
              <MaximumRemove error={seats.validationError}>
                <Trans>
                  (You can remove up to {seats.optionalExtraSeats} seats)
                </Trans>
              </MaximumRemove>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Sign red>-</Sign>
              <SeatInput
                error={seats.validationError}
                autoFocus
                value={removeSeatsAmount}
                onChange={e => seats.Update('remove', e.target.value)}
              />
            </SeatsFormItemValue>
          </SeatsFormItem>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <b>
                  <Trans>New total seats</Trans>:
                </b>
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{newTotalSeats}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <FullWidthDivider margin='0px 0px 20px 0px' />
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>Cost per seat</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{displayPerSeatAmount}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>Total savings</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{displaySavingsAmount}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <FullWidthDivider margin='0px 0px 20px 0px' />
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <Trans>Current monthly total</Trans>:
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>{currentMonthlyDisplayAmount}</Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <SeatsFormItem>
            <SeatsFormItemTitle>
              <Paragraph>
                <b>
                  <Trans>New monthly total</Trans>:
                </b>
              </Paragraph>
            </SeatsFormItemTitle>
            <SeatsFormItemValue>
              <Paragraph>
                <b>{newFinalDisplayAmount}</b>
              </Paragraph>
            </SeatsFormItemValue>
          </SeatsFormItem>
          <FullWidthDivider margin='0px 0px 20px 0px' />
          <ButtonGroup>
            <ButtonStyled
              size='small'
              variant='destructive'
              marginRight='5px'
              onClick={() => seats.SetFormVisibility(null)}
              text='Cancel'
            />

            <ButtonStyled
              size='small'
              marginLeft='5px'
              onClick={seats.ConfirmRemove}
              disabled={!preview}
              text='Save'
            />
          </ButtonGroup>
        </FormWrapper>
      </SeatsFormWrapper>
    );
  }),
);

RemoveSeatsForm.propTypes = {
  paymentSpace: PropTypes.object,
  paymentSpacePreview: PropTypes.object,
};
